// We listen every time a grid/template/content is initialized.
window.WP_Grid_Builder && WP_Grid_Builder.on( 'init', function( wpgb ) {

  // console.dir( wpgb ); // Holds all instances.

  // Some grids (like simple related posts) may not expose facets,
  // so guard against missing facet API before attaching listeners.
  if ( ! wpgb.facets || typeof wpgb.facets.on !== 'function' ) {
    return;
  }

  wpgb.facets.on( 'change', function( slug, values ) {
    // console.log(slug)
    // ScrollTrigger.refresh(true)

    if ( slug === 'load_more' ) {
      ScrollTrigger.refresh(true)
    }

    if ( slug === 'broker_map' ) {
      wpgb.facets.reset( ['find_a_broker'] );
    }

    if ( slug === 'find_a_broker' ) {
      wpgb.facets.reset( ['broker_map'] );
    }
  } );

} );